<ng-container>
  <ul ngbNav #nav="ngbNav" class="nav-tabs" [destroyOnHide]="false">
    <!-- Mipro MISONET scada-->
    <li ngbNavItem *ngIf="this.tenantConfig.influxMeasurements">
      <a ngbNavLink>{{ 'MISONET' | translate }} </a>
      <ng-template ngbNavContent>
        <qm-influx-graph
          #influxGraph
          metadataType="misonet"
          [bucket]="this.tenantConfig.influxMeasurements.bucket"
          [measurement]="this.tenantConfig.influxMeasurements.measurement"
          [filterFields]="['tunnus', 'symboli', '_field']"
          [filterLabelFields]="{'tunnus': 'nimi', 'symboli': 'kuvaus'}"
          [filterDefaults]="{'_field': 'laskuri'}"
          windowField="_field"
          unitFieldName="yksikkö">
        </qm-influx-graph>
      </ng-template>
    </li>
    <!-- V2L laboratory system (V2L is the 'low-level system' -name) -->
    <!-- V2L system is authored and engineered by "Suomen vesiensuojeluyhdistysten liitto ry" -->
    <!-- In Finnish water business, there are multiple different laboratory systems in use -->
    <li ngbNavItem *ngIf="this.tenantConfig.v2lMeasurements">
      <a ngbNavLink>{{ 'SVYL labra' | translate }} </a>
      <ng-template ngbNavContent>
        <qm-influx-graph
          #influxGraph
          metadataType="v2l"
          [bucket]="this.tenantConfig.v2lMeasurements.bucket"
          [measurement]="this.tenantConfig.v2lMeasurements.measurement"
          [filterFields]="['NaytteenottoMatka.Naytteenotto.NaytteenottoPaikka.properties.nimi', 'NaytteenottoMatka.Naytteenotto.Nayte.Analyysitulos.MaaritysmenetelmaNimi']"
          unitFieldName="NaytteenottoMatka.Naytteenotto.Nayte.Analyysitulos">
        </qm-influx-graph>
      </ng-template>
    </li>
    <!-- VALMET DNA scada -->
    <!-- At moment, neve tenant is supported, future tenants need work with "tagname's mappings / linkings" -->
    <li ngbNavItem *ngIf="tenant === 14">
      <a ngbNavLink>{{ 'Valmet DNA' | translate }} </a>
      <ng-template ngbNavContent>
        <qm-neve-measurements></qm-neve-measurements>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</ng-container>
